// extracted by mini-css-extract-plugin
module.exports = {"twoInput":"Steps_twoInput__3KUSP","inputStyle":"Steps_inputStyle__1Yd7g"};